import { select, call, put } from 'redux-saga/effects';
import bugsnagClient from '../../../services/bugsnag/bugsnag';
import { setChatAssistantQuota } from '../../../state/assistant/assistantQuotaSlice';
import { backendClient } from '../../../services/api/backend-client';

export function* fetchChatAssistantQuotaSaga(action) {
    try {
        const { data } = yield call(
            [backendClient, backendClient.get],
            '/realtime/quota/chat'
        );

        yield put(setChatAssistantQuota(data));

    } catch (err) {
        const status = err?.response?.status;
        bugsnagClient.notify(err);
        console.error('Failed to fetch chat assistant quota:', status, err?.message);
    }
}